function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "model-linear-gradient",
  y1: 86.39,
  x2: 769.16,
  y2: 86.39,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.33,
  stopColor: "#202031"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.43,
  stopColor: "#26263f"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.63,
  stopColor: "#363763"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.9,
  stopColor: "#4f529c"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.93,
  stopColor: "#5356a5"
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "model-horizontal-lines"
}, /*#__PURE__*/React.createElement("line", {
  x1: 768.03,
  y1: 1.65,
  x2: 0.03,
  y2: 1.65,
  fill: "none",
  stroke: "#5356a5",
  strokeMiterlimit: 10,
  opacity: 0.2
}), /*#__PURE__*/React.createElement("line", {
  x1: 0.03,
  y1: 29.84,
  x2: 768.03,
  y2: 29.84,
  fill: "none",
  stroke: "#5356a5",
  strokeMiterlimit: 10,
  opacity: 0.2
}), /*#__PURE__*/React.createElement("line", {
  x1: 0.03,
  y1: 58.03,
  x2: 768.03,
  y2: 58.03,
  fill: "none",
  stroke: "#5356a5",
  strokeMiterlimit: 10,
  opacity: 0.2
}), /*#__PURE__*/React.createElement("line", {
  x1: 0.03,
  y1: 86.21,
  x2: 768.03,
  y2: 86.21,
  fill: "none",
  stroke: "#5356a5",
  strokeMiterlimit: 10,
  opacity: 0.2
}), /*#__PURE__*/React.createElement("line", {
  x1: 0.03,
  y1: 114.4,
  x2: 768.03,
  y2: 114.4,
  fill: "none",
  stroke: "#5356a5",
  strokeMiterlimit: 10,
  opacity: 0.2
}), /*#__PURE__*/React.createElement("line", {
  x1: 0.03,
  y1: 142.59,
  x2: 768.03,
  y2: 142.59,
  fill: "none",
  stroke: "#5356a5",
  strokeMiterlimit: 10,
  opacity: 0.2
}), /*#__PURE__*/React.createElement("line", {
  x1: 0.03,
  y1: 170.78,
  x2: 768.03,
  y2: 170.78,
  fill: "none",
  stroke: "#5356a5",
  strokeMiterlimit: 10,
  opacity: 0.2
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "model-graph",
  className: "scaleable-vector-line",
  d: "M0 170.78s531.22-7 768-169.13",
  fill: "none",
  stroke: "url(#model-linear-gradient)",
  strokeMiterlimit: 10,
  strokeWidth: 4,
  strokeDasharray: "795px, 805px"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "model-indicators"
}, /*#__PURE__*/React.createElement("line", {
  x1: 198.18,
  y1: 11.05,
  x2: 215.01,
  y2: 11.05,
  fill: "none",
  stroke: "#5356a5",
  strokeMiterlimit: 10,
  opacity: 0.2
}), /*#__PURE__*/React.createElement("line", {
  x1: 198.18,
  y1: 39.23,
  x2: 215.01,
  y2: 39.23,
  fill: "none",
  stroke: "#5356a5",
  strokeMiterlimit: 10,
  opacity: 0.2
}), /*#__PURE__*/React.createElement("line", {
  x1: 198.18,
  y1: 67.42,
  x2: 215.01,
  y2: 67.42,
  fill: "none",
  stroke: "#5356a5",
  strokeMiterlimit: 10,
  opacity: 0.2
}), /*#__PURE__*/React.createElement("line", {
  x1: 198.18,
  y1: 95.61,
  x2: 215.01,
  y2: 95.61,
  fill: "none",
  stroke: "#5356a5",
  strokeMiterlimit: 10,
  opacity: 0.2
}), /*#__PURE__*/React.createElement("line", {
  x1: 198.18,
  y1: 123.8,
  x2: 215.01,
  y2: 123.8,
  fill: "none",
  stroke: "#5356a5",
  strokeMiterlimit: 10,
  opacity: 0.2
}), /*#__PURE__*/React.createElement("line", {
  x1: 198.18,
  y1: 151.99,
  x2: 215.01,
  y2: 151.99,
  fill: "none",
  stroke: "#5356a5",
  strokeMiterlimit: 10,
  opacity: 0.2
}), /*#__PURE__*/React.createElement("line", {
  x1: 198.18,
  y1: 20.44,
  x2: 215.01,
  y2: 20.44,
  fill: "none",
  stroke: "#5356a5",
  strokeMiterlimit: 10,
  opacity: 0.2
}), /*#__PURE__*/React.createElement("line", {
  x1: 198.18,
  y1: 48.63,
  x2: 215.01,
  y2: 48.63,
  fill: "none",
  stroke: "#5356a5",
  strokeMiterlimit: 10,
  opacity: 0.2
}), /*#__PURE__*/React.createElement("line", {
  x1: 198.18,
  y1: 76.82,
  x2: 215.01,
  y2: 76.82,
  fill: "none",
  stroke: "#5356a5",
  strokeMiterlimit: 10,
  opacity: 0.2
}), /*#__PURE__*/React.createElement("line", {
  x1: 198.18,
  y1: 105.01,
  x2: 215.01,
  y2: 105.01,
  fill: "none",
  stroke: "#5356a5",
  strokeMiterlimit: 10,
  opacity: 0.2
}), /*#__PURE__*/React.createElement("line", {
  x1: 198.18,
  y1: 133.19,
  x2: 215.01,
  y2: 133.19,
  fill: "none",
  stroke: "#5356a5",
  strokeMiterlimit: 10,
  opacity: 0.2
}), /*#__PURE__*/React.createElement("line", {
  x1: 198.18,
  y1: 161.38,
  x2: 215.01,
  y2: 161.38,
  fill: "none",
  stroke: "#5356a5",
  strokeMiterlimit: 10,
  opacity: 0.2
}));

function SvgAnimation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "model-animation",
    viewBox: "0 0 769.16 172.78",
    width: 769.16,
    height: 172.78
  }, props), _ref, _ref2, _ref3, _ref4);
}

export default "data:image/svg+xml;base64,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";
export { SvgAnimation as ReactComponent };